import React from 'react';
import { Star } from 'lucide-react';
interface TestimonialProps {
  name: string;
  age: number;
  city: string;
  quote: string;
  initial: string;
}
export function TestimonialCard({
  name,
  age,
  city,
  quote,
  initial
}: TestimonialProps) {
  return <div className="bg-white p-6 rounded-xl shadow-md border border-gray-100 hover:shadow-lg transition-shadow duration-300 flex flex-col h-full" data-id="element-8">
      <div className="flex items-center gap-1 mb-4" data-id="element-9">
        {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-4 h-4 fill-[#f5a623] text-[#f5a623]" data-id="element-10" />)}
      </div>

      <blockquote className="flex-grow mb-6" data-id="element-11">
        <p className="text-gray-700 italic leading-relaxed" data-id="element-12">"{quote}"</p>
      </blockquote>

      <div className="flex items-center gap-3 mt-auto" data-id="element-13">
        <div className="w-10 h-10 rounded-full bg-[#e8f5e9] flex items-center justify-center text-[#2d5016] font-bold text-lg" data-id="element-14">
          {initial}
        </div>
        <div data-id="element-15">
          <p className="font-semibold text-gray-900 text-sm" data-id="element-16">
            {name}, {age}
          </p>
          <p className="text-xs text-gray-500" data-id="element-17">{city}</p>
        </div>
      </div>
    </div>;
}